import { Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material'
import React from 'react'

const ConfirmDialog = ({title, body, onCancel, onSubmit, open, setOpen, disabledSubmit, ...otherProps}) => {
  const closeDialog = () => setOpen(false);

  const handleCancel = () => {
    onCancel();
    closeDialog();
  }

  const handleSubmit = () => {
    onSubmit();
    closeDialog();
  }

  return (
    <Dialog open={open} onClose={() => closeDialog()} {...otherProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button disabled={disabledSubmit} onClick={handleSubmit}>Ok</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog